function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var _require = require('./ordering'),
  shouldApplyEvent = _require.shouldApplyEvent;
var _require2 = require('./constants'),
  BUG_PRIORITIES = _require2.BUG_PRIORITIES,
  BUG_SEVERITIES = _require2.BUG_SEVERITIES,
  BUG_STATUSES = _require2.BUG_STATUSES,
  MAX_TITLE_LENGTH = _require2.MAX_TITLE_LENGTH;
var BugsDatabase = /*#__PURE__*/function () {
  function BugsDatabase(app, mod) {
    _classCallCheck(this, BugsDatabase);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(BugsDatabase, [{
    key: "query",
    value: function () {
      var _query = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(sql) {
        var params,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.n = 1;
              return this.app.storage.queryDatabase(sql, params, 'bugs');
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = [];
            case 2:
              return _context.a(2, _t);
          }
        }, _callee, this);
      }));
      function query(_x) {
        return _query.apply(this, arguments);
      }
      return query;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(sql) {
        var params,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              return _context2.a(2, this.app.storage.runDatabase(sql, params, 'bugs'));
          }
        }, _callee2, this);
      }));
      function run(_x2) {
        return _run.apply(this, arguments);
      }
      return run;
    }()
  }, {
    key: "getBug",
    value: function () {
      var _getBug = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(rootTxSig) {
        var rows;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.query('SELECT * FROM bugs WHERE root_tx_sig = $root_tx_sig LIMIT 1', {
                $root_tx_sig: rootTxSig
              });
            case 1:
              rows = _context3.v;
              return _context3.a(2, rows[0] || null);
          }
        }, _callee3, this);
      }));
      function getBug(_x3) {
        return _getBug.apply(this, arguments);
      }
      return getBug;
    }()
  }, {
    key: "hasEvent",
    value: function () {
      var _hasEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(txSig) {
        var rows;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.query('SELECT * FROM bug_events WHERE tx_sig = $tx_sig LIMIT 1', {
                $tx_sig: txSig
              });
            case 1:
              rows = _context4.v;
              return _context4.a(2, rows[0] || null);
          }
        }, _callee4, this);
      }));
      function hasEvent(_x4) {
        return _hasEvent.apply(this, arguments);
      }
      return hasEvent;
    }()
  }, {
    key: "reconcileEventConfirmation",
    value: function () {
      var _reconcileEventConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(txSig, blockId, txOrdinal) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (blockId) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.n = 2;
              return this.run("UPDATE bug_events\n         SET block_id = $block_id, tx_ordinal = $tx_ordinal\n       WHERE tx_sig = $tx_sig AND block_id = 0", {
                $block_id: blockId,
                $tx_ordinal: txOrdinal,
                $tx_sig: txSig
              });
            case 2:
              _context5.n = 3;
              return this.run("UPDATE bugs\n         SET latest_metadata_block_id = $block_id,\n             latest_metadata_tx_ordinal = $tx_ordinal\n       WHERE latest_metadata_tx_sig = $tx_sig AND latest_metadata_block_id = 0", {
                $block_id: blockId,
                $tx_ordinal: txOrdinal,
                $tx_sig: txSig
              });
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function reconcileEventConfirmation(_x5, _x6, _x7) {
        return _reconcileEventConfirmation.apply(this, arguments);
      }
      return reconcileEventConfirmation;
    }()
  }, {
    key: "recordEvent",
    value: function () {
      var _recordEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(event, applied) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.run("INSERT OR IGNORE INTO bug_events\n        (tx_sig, bug_id, request, action, signer_publickey, block_id, tx_ordinal,\n         tx_timestamp, applied, processed_at)\n       VALUES\n        ($tx_sig, $bug_id, $request, $action, $signer_publickey, $block_id, $tx_ordinal,\n         $tx_timestamp, $applied, $processed_at)", {
                $tx_sig: event.tx_sig,
                $bug_id: event.bug_id,
                $request: event.request,
                $action: event.action || '',
                $signer_publickey: event.signer,
                $block_id: event.block_id,
                $tx_ordinal: event.tx_ordinal,
                $tx_timestamp: event.tx_timestamp,
                $applied: applied ? 1 : 0,
                $processed_at: Date.now()
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function recordEvent(_x8, _x9) {
        return _recordEvent.apply(this, arguments);
      }
      return recordEvent;
    }()
  }, {
    key: "createBug",
    value: function () {
      var _createBug = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(data, event, reporterVerified) {
        var completedAt;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              completedAt = data.status === 'completed' ? event.tx_timestamp : 0;
              _context7.n = 1;
              return this.run("INSERT INTO bugs\n        (root_tx_sig, source_tx_sig, title, status, severity, priority, weight,\n         reporter_publickey, reporter_verified, added_by_publickey, assignee_publickey,\n         created_at, updated_at, completed_at, tracked, latest_metadata_tx_sig,\n         latest_metadata_previous_tx_sig, latest_metadata_block_id,\n         latest_metadata_tx_ordinal, latest_metadata_timestamp)\n       VALUES\n        ($root_tx_sig, $source_tx_sig, $title, $status, $severity, $priority, $weight,\n         $reporter_publickey, $reporter_verified, $added_by_publickey, $assignee_publickey,\n         $created_at, $updated_at, $completed_at, 1, $latest_metadata_tx_sig,\n         $latest_metadata_previous_tx_sig, $latest_metadata_block_id,\n         $latest_metadata_tx_ordinal, $latest_metadata_timestamp)", {
                $root_tx_sig: data.root_tx_sig,
                $source_tx_sig: data.source_tx_sig,
                $title: data.title,
                $status: data.status,
                $severity: data.severity,
                $priority: data.priority,
                $weight: data.weight,
                $reporter_publickey: data.reporter_publickey,
                $reporter_verified: reporterVerified ? 1 : 0,
                $added_by_publickey: event.signer,
                $assignee_publickey: data.assignee_publickey,
                $created_at: event.tx_timestamp,
                $updated_at: event.tx_timestamp,
                $completed_at: completedAt,
                $latest_metadata_tx_sig: event.tx_sig,
                $latest_metadata_previous_tx_sig: event.previous_metadata_tx_sig || '',
                $latest_metadata_block_id: event.block_id,
                $latest_metadata_tx_ordinal: event.tx_ordinal,
                $latest_metadata_timestamp: event.tx_timestamp
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function createBug(_x0, _x1, _x10) {
        return _createBug.apply(this, arguments);
      }
      return createBug;
    }()
  }, {
    key: "replaceBugFromCreate",
    value: function () {
      var _replaceBugFromCreate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(data, event, reporterVerified) {
        var completedAt;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              completedAt = data.status === 'completed' ? event.tx_timestamp : 0;
              _context8.n = 1;
              return this.run("UPDATE bugs SET\n         source_tx_sig = $source_tx_sig,\n         title = $title,\n         status = $status,\n         severity = $severity,\n         priority = $priority,\n         weight = $weight,\n         reporter_publickey = $reporter_publickey,\n         reporter_verified = CASE\n           WHEN $reporter_verified = 1 THEN 1\n           ELSE reporter_verified\n         END,\n         added_by_publickey = $added_by_publickey,\n         assignee_publickey = $assignee_publickey,\n         updated_at = $updated_at,\n         completed_at = $completed_at,\n         tracked = 1,\n         latest_metadata_tx_sig = $latest_metadata_tx_sig,\n         latest_metadata_previous_tx_sig = $latest_metadata_previous_tx_sig,\n         latest_metadata_block_id = $latest_metadata_block_id,\n         latest_metadata_tx_ordinal = $latest_metadata_tx_ordinal,\n         latest_metadata_timestamp = $latest_metadata_timestamp\n       WHERE root_tx_sig = $root_tx_sig", {
                $root_tx_sig: data.root_tx_sig,
                $source_tx_sig: data.source_tx_sig,
                $title: data.title,
                $status: data.status,
                $severity: data.severity,
                $priority: data.priority,
                $weight: data.weight,
                $reporter_publickey: data.reporter_publickey,
                $reporter_verified: reporterVerified ? 1 : 0,
                $added_by_publickey: event.signer,
                $assignee_publickey: data.assignee_publickey,
                $updated_at: event.tx_timestamp,
                $completed_at: completedAt,
                $latest_metadata_tx_sig: event.tx_sig,
                $latest_metadata_previous_tx_sig: event.previous_metadata_tx_sig || '',
                $latest_metadata_block_id: event.block_id,
                $latest_metadata_tx_ordinal: event.tx_ordinal,
                $latest_metadata_timestamp: event.tx_timestamp
              });
            case 1:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function replaceBugFromCreate(_x11, _x12, _x13) {
        return _replaceBugFromCreate.apply(this, arguments);
      }
      return replaceBugFromCreate;
    }()
  }, {
    key: "applyUpdate",
    value: function () {
      var _applyUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(bug, data, event) {
        var fields, _fields$data$action, column, value, params;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              fields = {
                'set-title': ['title', data.title],
                'set-status': ['status', data.status],
                'set-severity': ['severity', data.severity],
                'set-priority': ['priority', data.priority],
                'set-weight': ['weight', data.weight],
                'set-assignee': ['assignee_publickey', data.assignee_publickey],
                untrack: ['tracked', 0],
                retrack: ['tracked', 1]
              };
              _fields$data$action = _slicedToArray(fields[data.action], 2), column = _fields$data$action[0], value = _fields$data$action[1];
              params = {
                $root_tx_sig: bug.root_tx_sig,
                $value: value,
                $updated_at: event.tx_timestamp,
                $completed_at: data.action === 'set-status' ? data.status === 'completed' ? event.tx_timestamp : 0 : bug.completed_at,
                $latest_metadata_tx_sig: event.tx_sig,
                $latest_metadata_previous_tx_sig: event.previous_metadata_tx_sig || '',
                $latest_metadata_block_id: event.block_id,
                $latest_metadata_tx_ordinal: event.tx_ordinal,
                $latest_metadata_timestamp: event.tx_timestamp
              };
              _context9.n = 1;
              return this.run("UPDATE bugs SET\n         ".concat(column, " = $value,\n         updated_at = $updated_at,\n         completed_at = $completed_at,\n         latest_metadata_tx_sig = $latest_metadata_tx_sig,\n         latest_metadata_previous_tx_sig = $latest_metadata_previous_tx_sig,\n         latest_metadata_block_id = $latest_metadata_block_id,\n         latest_metadata_tx_ordinal = $latest_metadata_tx_ordinal,\n         latest_metadata_timestamp = $latest_metadata_timestamp\n       WHERE root_tx_sig = $root_tx_sig"), params);
            case 1:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function applyUpdate(_x14, _x15, _x16) {
        return _applyUpdate.apply(this, arguments);
      }
      return applyUpdate;
    }()
  }, {
    key: "applyAcceptedEvent",
    value: function () {
      var _applyAcceptedEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(validation, event) {
        var reporterVerified,
          duplicate,
          bug,
          applied,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              reporterVerified = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : false;
              _context0.n = 1;
              return this.hasEvent(event.tx_sig);
            case 1:
              duplicate = _context0.v;
              if (!duplicate) {
                _context0.n = 3;
                break;
              }
              _context0.n = 2;
              return this.reconcileEventConfirmation(event.tx_sig, event.block_id, event.tx_ordinal);
            case 2:
              return _context0.a(2, {
                accepted: true,
                applied: Boolean(duplicate.applied),
                duplicate: true
              });
            case 3:
              _context0.n = 4;
              return this.getBug(event.bug_id);
            case 4:
              bug = _context0.v;
              if (!(!bug && validation.request === 'update bug')) {
                _context0.n = 5;
                break;
              }
              return _context0.a(2, {
                accepted: false,
                deferred: true,
                error: 'Bug create transaction has not arrived'
              });
            case 5:
              applied = !bug || shouldApplyEvent(bug, event);
              if (!(applied && validation.request === 'create bug')) {
                _context0.n = 9;
                break;
              }
              if (!bug) {
                _context0.n = 7;
                break;
              }
              _context0.n = 6;
              return this.replaceBugFromCreate(validation.data, event, reporterVerified);
            case 6:
              _context0.n = 8;
              break;
            case 7:
              _context0.n = 8;
              return this.createBug(validation.data, event, reporterVerified);
            case 8:
              _context0.n = 10;
              break;
            case 9:
              if (!applied) {
                _context0.n = 10;
                break;
              }
              _context0.n = 10;
              return this.applyUpdate(bug, validation.data, event);
            case 10:
              _context0.n = 11;
              return this.recordEvent(event, applied);
            case 11:
              return _context0.a(2, {
                accepted: true,
                applied: applied,
                duplicate: false
              });
          }
        }, _callee0, this);
      }));
      function applyAcceptedEvent(_x17, _x18) {
        return _applyAcceptedEvent.apply(this, arguments);
      }
      return applyAcceptedEvent;
    }()
  }, {
    key: "noteReply",
    value: function () {
      var _noteReply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(rootTxSig, timestamp) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return this.run("UPDATE bugs\n          SET reply_count = reply_count + 1,\n              updated_at = CASE WHEN updated_at < $timestamp THEN $timestamp ELSE updated_at END\n        WHERE root_tx_sig = $root_tx_sig AND tracked = 1", {
                $root_tx_sig: rootTxSig,
                $timestamp: timestamp
              });
            case 1:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function noteReply(_x19, _x20) {
        return _noteReply.apply(this, arguments);
      }
      return noteReply;
    }()
  }, {
    key: "listBugs",
    value: function () {
      var _listBugs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var filters,
          clauses,
          params,
          allowed,
          _i,
          _Object$keys,
          field,
          sort,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              filters = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
              clauses = ['tracked = 1'];
              params = {};
              if (filters.view === 'completed') clauses.push("status = 'completed'");else if (filters.view !== 'all') clauses.push("status != 'completed'");
              allowed = {
                status: BUG_STATUSES,
                severity: BUG_SEVERITIES,
                priority: BUG_PRIORITIES
              };
              for (_i = 0, _Object$keys = Object.keys(allowed); _i < _Object$keys.length; _i++) {
                field = _Object$keys[_i];
                if (allowed[field].includes(filters[field])) {
                  clauses.push("".concat(field, " = $").concat(field));
                  params["$".concat(field)] = filters[field];
                }
              }
              if (filters.assignee_publickey) {
                clauses.push('assignee_publickey = $assignee_publickey');
                params.$assignee_publickey = String(filters.assignee_publickey).slice(0, 128);
              }
              if (filters.reporter_publickey) {
                clauses.push('reporter_publickey = $reporter_publickey');
                params.$reporter_publickey = String(filters.reporter_publickey).slice(0, 128);
              }
              if (filters.search) {
                clauses.push("title LIKE $search ESCAPE '\\'");
                params.$search = "%".concat(String(filters.search).slice(0, MAX_TITLE_LENGTH).replace(/[\\%_]/g, '\\$&'), "%");
              }
              sort = {
                weight: 'weight ASC, updated_at DESC',
                updated: 'updated_at DESC, weight ASC',
                created: 'created_at DESC, weight ASC',
                severity: "CASE severity WHEN 'critical' THEN 0 WHEN 'high' THEN 1 WHEN 'medium' THEN 2 ELSE 3 END, weight ASC",
                priority: "CASE priority WHEN 'urgent' THEN 0 WHEN 'high' THEN 1 WHEN 'normal' THEN 2 ELSE 3 END, weight ASC"
              }[filters.sort] || 'weight ASC, updated_at DESC';
              return _context10.a(2, this.query("SELECT * FROM bugs WHERE ".concat(clauses.join(' AND '), " ORDER BY ").concat(sort, " LIMIT 500"), params));
          }
        }, _callee10, this);
      }));
      function listBugs() {
        return _listBugs.apply(this, arguments);
      }
      return listBugs;
    }()
  }, {
    key: "listPrunable",
    value: function () {
      var _listPrunable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(now) {
        var cutoff;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              cutoff = Number(now) - this.mod.completedRetentionMs;
              return _context11.a(2, this.query("SELECT * FROM bugs\n        WHERE status = 'completed' AND completed_at > 0 AND completed_at <= $cutoff", {
                $cutoff: cutoff
              }));
          }
        }, _callee11, this);
      }));
      function listPrunable(_x21) {
        return _listPrunable.apply(this, arguments);
      }
      return listPrunable;
    }()
  }]);
}();
module.exports = BugsDatabase;